import { useSetupExtraActivationData } from '@office-start/teaching-ui-service';
export var TuiExtraActivationDataLoader = function () {
    useSetupExtraActivationData();
    return null;
};
//# sourceMappingURL=TuiExtraSettingsLoader.js.map